module.exports = __webpack_public_path__ + "static/media/contentHome0.01fe5487.png";